import React from 'react';
import PropTypes from 'prop-types';

import Loader from 'src/core/components/Loader';

const redirect = (url) => {
  window.location.replace(url);
};

const AppRedirect = ({ url }) => {
  if (!url) {
    return null;
  }

  redirect(url);

  return <Loader isLoading />;
};

AppRedirect.propTypes = {
  url: PropTypes.string,
};

export default AppRedirect;
